var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import LengthInput from '@declaration/components/LengthInput.vue';
import Select from '@declaration/components/Select.vue';
import { ExternalDamageComponent } from '@declaration/components/externalDamage/ExternalDamageComponent';
import { PIPE_TYPE_CHOICES } from '@shared/constants/externalDamages/VisiblePipeConstants';
import { PIPE_LENGTH_TITLE, PIPE_TYPE_PLACEHOLDER, PIPE_TYPE_TITLE, } from '@declaration/constants/externalDamages/VisiblePipeConstants';
import { PipeType } from '@shared/types/api/roomDamage';
let VisiblePipe = class VisiblePipe extends ExternalDamageComponent {
    get typeTitle() {
        return this.translateExternalDamageKey(PIPE_TYPE_TITLE);
    }
    get typePlaceholder() {
        return this.translateExternalDamageKey(PIPE_TYPE_PLACEHOLDER);
    }
    get lengthTitle() {
        return this.translateExternalDamageKey(PIPE_LENGTH_TITLE);
    }
    get typeChoices() {
        return this.getExternalDamageChoices(PIPE_TYPE_CHOICES);
    }
    get pipeType() {
        var _a;
        return (_a = this.externalDamage.pipeType) !== null && _a !== void 0 ? _a : null;
    }
    set pipeType(pipeType) {
        this.updateExternalDamage({
            pipeType,
            pipeLength: [PipeType.FLEXIBLE, null].includes(pipeType)
                ? null
                : this.externalDamage.pipeLength,
        });
    }
    get pipeLength() {
        var _a;
        return (_a = this.externalDamage.pipeLength) !== null && _a !== void 0 ? _a : 0;
    }
    set pipeLength(pipeLength) {
        this.updateExternalDamage({ pipeLength });
    }
    get showLength() {
        return [PipeType.COPPER, PipeType.PEX, PipeType.UNKNOWN].includes(this.pipeType);
    }
};
VisiblePipe = __decorate([
    Component({
        components: {
            Select,
            LengthInput,
        },
    })
], VisiblePipe);
export default VisiblePipe;
